import DefaultLayout from "@/layouts/DefaultLayout";
import SalesLeadDeleteDialog from "kinnect-front/CounterSales/SalesLeads/SalesLeadDeleteDialog";
import SalesLeadForm from "kinnect-front/CounterSales/SalesLeads/SalesLeadForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { SalesLead } from "kinnect-models";

export default {
	name: "SalesLeadPage",

	metaInfo() {
		const title = this.editing
			? "View Sales Lead"
			: "Add Sales Lead";

		return { title };
	},

	props: { idSalesLead: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "sales_leads",
		deleteDialogOpen: false,
		salesLead: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idSalesLead );
		},

		genDeleteDialog() {
			if ( this.editing && this.salesLead && this.canDelete ) {
				return <SalesLeadDeleteDialog
					item={this.salesLead}
					onConfirm={() => this.salesLead.delete()}
					redirect={[ "back", { name: "salesLeads" } ]}
					vModel={this.deleteDialogOpen}
				></SalesLeadDeleteDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete",
					tooltip: "Delete this sales lead"
				};
			}
		}
	},

	methods: {
		async fetchSalesLead() {
			if ( this.editing ) {
				this.salesLead = await SalesLead
				.include( [ "statuses" ] )
				.findPageModel( this.idSalesLead );
			}
		},

		async fetch() {
			await this.fetchSalesLead();
		}
	},

	render() {
		return <DefaultLayout>
			<SalesLeadForm
				loading={this.$wait.is( "find sales lead" )}
				readonly={this.editing ? !this.canEdit : false}
				salesLead={this.salesLead}
			></SalesLeadForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
